import { Link, useMatches } from 'react-router-dom'
//import { Helmet } from 'react-helmet-async'
import { Head } from 'vite-react-ssg'

export default function Breadcrumb({ className = '' }) {
  const matches = useMatches()

  // Walk matches from leaf → root and use the first (deepest) one that
  // declared breadcrumb metadata via its route's `handle` prop.
  const current = [...matches].reverse().find((m) => m.handle?.crumb)
  if (!current) return null // Home and any route without a `handle.crumb` show no breadcrumb

  // const trail = [{ label: 'Home', href: '/' }, ...current.handle.crumb.map((label) => ({ label }))]
  const trail = [{ label: 'Home', href: '/' }, ...current.handle.crumb]

  const origin = typeof window !== 'undefined' ? window.location.origin : ''

  // Google-recommended structured data so the trail can appear in search results.
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: trail.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.label,
      ...(item.href ? { item: `${origin}${item.href}` } : {}),
    })),
  }

  return (
    <>
      {/* <Helmet> */}
      <Head>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      {/* </Helmet> */}
</Head>
      <div className={`breadcrumb-bar ${className}`.trim()}>
       
          <nav aria-label="Breadcrumb" className="breadcrumb" data-aos="fade-up">
            <ol>
              {trail.map((item, i) => {
                const isLast = i === trail.length - 1
                return (
                  <li key={`${item.label}-${i}`}>
                    {i > 0 && <span className="breadcrumb-sep" aria-hidden="true">&gt;</span>}
                    {isLast || !item.href ? (
                      <span aria-current={isLast ? 'page' : undefined}>{item.label}</span>
                    ) : (
                      <Link to={item.href}>{item.label}</Link>
                    )}
                  </li>
                )
              })}
            </ol>
          </nav>
       
      </div>
    </>
  )
}